<div class="manual-reservation-wrapper">
  <!-- defaultplus tenants: service-catalog, slot-aware booking form -->
  @if (isDefaultPlus) {
  <app-defaultplus-booking
    [companyName]="companyName || ''"
  ></app-defaultplus-booking>
  }

  <!-- restaurant / default tenants: the original table-reservation flow -->
  @if (!isDefaultPlus) { @if (isLoading) {
  <div
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
    style="background: rgba(255, 255, 255, 0.6); z-index: 10"
  >
    <div class="spinner-border" role="status" aria-hidden="true"></div>
  </div>
  } @if (!isCompleted) {
  <c-card class="modern-card">
    <div class="header-minimal">
      @if (userId) {
      <app-business-logo
        [tenantId]="userId"
        [label]="companyName || 'Business logo'"
      ></app-business-logo>
      }
      <span class="eyebrow text-uppercase">
        {{ "MANUAL_RESERVATION.CREATE_NEW_RESERVATION" | translate }}
      </span>
      <h2 class="company-name mb-0">
        {{ companyName || "Sagel" }}
      </h2>
      <span class="header-date">
        {{ "MANUAL_RESERVATION.TODAY" | translate }} ·
        {{ today | date : "MMM d, y" }}
      </span>
    </div>
    <c-card-body class="body-content">
      <form (ngSubmit)="onSubmit()" class="modern-form">
        <div class="step-progress">
          <button
            type="button"
            class="step-pill"
            [ngClass]="{
              active: currentStep === 1,
              complete: isStepOneValid()
            }"
            (click)="goToStep(1)"
          >
            <span class="step-number">1</span>
            <span class="step-label">{{
              "MANUAL_RESERVATION.STEP_DETAILS" | translate
            }}</span>
          </button>
          <button
            type="button"
            class="step-pill"
            [ngClass]="{
              active: currentStep === 2,
              complete: isStepTwoValid()
            }"
            [disabled]="!canAccessStep(2)"
            (click)="goToStep(2)"
          >
            <span class="step-number">2</span>
            <span class="step-label">{{
              "MANUAL_RESERVATION.STEP_SESSION_TIME" | translate
            }}</span>
          </button>
          <button
            type="button"
            class="step-pill"
            [ngClass]="{
              active: currentStep === 3,
              complete: isStepThreeValid()
            }"
            [disabled]="!canAccessStep(3)"
            (click)="goToStep(3)"
          >
            <span class="step-number">3</span>
            <span class="step-label">{{
              "MANUAL_RESERVATION.STEP_CONTACT" | translate
            }}</span>
          </button>
        </div>
        <div class="step-note mb-3">
          {{
            "MANUAL_RESERVATION.STEP_INDICATOR"
              | translate : { current: currentStep, total: totalSteps }
          }}
        </div>
        @if (stepValidationMessage) {
        <div class="step-error mb-3">
          {{ stepValidationMessage }}
        </div>
        } @if (currentStep === 1) {
        <div class="step-panel">
          <div class="row g-3 g-md-4">
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-calendar me-2"></i>
                {{ "MANUAL_RESERVATION.SELECT_START_DATE" | translate }}
              </label>
              <c-date-picker
                closeOnSelect
                [(ngModel)]="form.startDate"
                locale="en-GB"
                format="dd/MM/yyyy"
                name="startDate"
                (ngModelChange)="onStartDateChange($event)"
                [disabledDates]="fullyClosedDates"
                [dateFilter]="dateFilter"
                [minDate]="today"
                required
              ></c-date-picker>
            </div>
            <!-- Single-salon tenants: auto-selected in the component, picker hidden -->
            @if (!isSingleSalon) {
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-building me-2"></i>
                {{ "MANUAL_RESERVATION.SALON" | translate }}
              </label>
              <select
                class="form-select"
                [(ngModel)]="form.salonName"
                name="salonName"
                (ngModelChange)="onSalonChange($event)"
                required
              >
                <option value="" disabled>
                  {{ "MANUAL_RESERVATION.SALON" | translate }}
                </option>
                @for (s of salons; track trackBySalonName($index, s)) {
                <option [value]="s.salon_name">{{ s.salon_name }}</option>
                }
              </select>
            </div>
            }
          </div>
          <div class="row g-3 g-md-4 mt-1 mt-md-3">
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-user me-2"></i>
                {{ "MANUAL_RESERVATION.NUMBER_OF_PEOPLE" | translate }}
              </label>
              <input
                type="number"
                min="1"
                class="form-control"
                [(ngModel)]="form.personCount"
                name="personCount"
                (ngModelChange)="stepValidationMessage = ''"
                required
              />
              @if (partySizeExceeded) {
              <div class="text-danger mt-2">
                {{ partySizeLimitMessage() }}
              </div>
              }
            </div>
            @if (experienceSelectionActive) {
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-restaurant me-2"></i>
                {{ "MANUAL_RESERVATION.EXPERIENCE_LABEL" | translate }}
              </label>
              <select
                class="form-select"
                [(ngModel)]="selectedExperience"
                name="experience"
                (ngModelChange)="stepValidationMessage = ''"
                required
              >
                <option value="" disabled>
                  {{ "MANUAL_RESERVATION.EXPERIENCE_PLACEHOLDER" | translate }}
                </option>
                @for (e of experiences; track e) {
                <option [value]="e.name">{{ e.displayName || e.name }}</option>
                } @if (experiencesAllowCustom) {
                <option [value]="OTHER_EXPERIENCE">
                  {{ "MANUAL_RESERVATION.EXPERIENCE_OTHER" | translate }}
                </option>
                }
              </select>
              @if (selectedExperience === OTHER_EXPERIENCE) {
              <input
                type="text"
                class="form-control mt-2"
                maxlength="200"
                [(ngModel)]="customExperience"
                name="customExperience"
                (ngModelChange)="stepValidationMessage = ''"
                placeholder="{{
                  'MANUAL_RESERVATION.EXPERIENCE_CUSTOM_PLACEHOLDER' | translate
                }}"
              />
              }
            </div>
            }
          </div>
        </div>
        } @if (currentStep === 2) {
        <div class="step-panel">
          <div class="row g-3 g-md-4 mt-1 mt-md-3">
            <div class="col-12">
              <label class="form-label">
                <i class="cil-calendar me-2"></i>
                {{ "MANUAL_RESERVATION.SELECT_SESSION" | translate }}
              </label>
              <div class="session-cards">
                @for (s of sessions; track s) {
                <button
                  type="button"
                  class="session-card"
                  [class.session-card--selected]="selectedSessionId === s.id"
                  [class.session-card--closed]="isSessionClosed(s)"
                  [disabled]="isSessionClosed(s)"
                  (click)="selectSession(s)"
                >
                  <div class="session-card__top">
                    <span class="session-card__name">{{ s.name }}</span>
                  </div>
                  <span class="session-card__time"
                    >{{ s.start_time }} – {{ s.end_time }}</span
                  >
                  @if (isSessionClosed(s)) {
                  <span class="session-card__meta session-card__meta--closed">
                    {{ "MANUAL_RESERVATION.UNAVAILABLE" | translate }}
                  </span>
                  }
                </button>
                }
              </div>
            </div>
            <div class="col-12">
              <label class="form-label">
                <i class="cil-clock me-2"></i>
                {{ "MANUAL_RESERVATION.SELECT_START_TIME" | translate }}
              </label>
              <input
                type="hidden"
                [(ngModel)]="form.startTime"
                name="startTime"
                required
              />
              @if (availableTimes.length) {
              <div class="time-slot-picker">
                @for (t of availableTimes; track t) {
                <button
                  type="button"
                  class="time-slot"
                  [class.time-slot--selected]="form.startTime === t"
                  (click)="selectStartTime(t)"
                >
                  {{ t }}
                </button>
                }
              </div>
              } @else {
              <div class="time-slot-empty">
                {{
                  "MANUAL_RESERVATION.SELECT_START_TIME_PLACEHOLDER" | translate
                }}
              </div>
              }
            </div>
          </div>
        </div>
        } @if (currentStep === 3) {
        <div class="step-panel">
          <div class="row g-3 g-md-4 mt-1 mt-md-3">
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-text me-2"></i>
                {{ "MANUAL_RESERVATION.NAME" | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="form.name"
                name="name"
                (ngModelChange)="stepValidationMessage = ''"
                required
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-phone me-2"></i>
                {{ "MANUAL_RESERVATION.PHONE_NUMBER" | translate }}
              </label>
              <input
                type="tel"
                class="form-control"
                placeholder="{{
                  'MANUAL_RESERVATION.PHONE_PLACEHOLDER' | translate
                }}"
                [(ngModel)]="form.phoneNumber"
                name="phoneNumber"
                (ngModelChange)="stepValidationMessage = ''"
                required
              />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">
                <i class="cil-envelope me-2"></i>
                {{ "MANUAL_RESERVATION.EMAIL_ADDRESS" | translate }}
              </label>
              <input
                type="email"
                class="form-control"
                placeholder="{{
                  'MANUAL_RESERVATION.EMAIL_PLACEHOLDER' | translate
                }}"
                [(ngModel)]="form.emailAddress"
                name="emailAddress"
                (ngModelChange)="stepValidationMessage = ''"
                required
              />
            </div>
            <div class="col-12">
              <label class="form-label">
                <i class="cil-notes me-2"></i>
                {{ "MANUAL_RESERVATION.NOTES" | translate }}
                <span class="label-optional">{{
                  "MANUAL_RESERVATION.OPTIONAL" | translate
                }}</span>
              </label>
              <textarea
                class="form-control"
                rows="3"
                maxlength="500"
                [(ngModel)]="form.notes"
                name="notes"
                placeholder="{{
                  'MANUAL_RESERVATION.NOTES_PLACEHOLDER' | translate
                }}"
              ></textarea>
            </div>
            @if (guards.length > 0) {
            <div class="col-12">
              <div class="guard-consent-box">
                <label class="form-label">
                  <i class="cil-shield-alt me-2"></i>
                  {{ "MANUAL_RESERVATION.GUARDS_TITLE" | translate }}
                </label>
                @for (guard of guards; track guard) {
                <div class="form-check guard-consent-item">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="guard-consent-{{ guard.id }}"
                    [checked]="guardConsents[guard.id] === true"
                    (change)="toggleGuardConsent(guard)"
                  />
                  <label
                    class="form-check-label"
                    for="guard-consent-{{ guard.id }}"
                  >
                    {{ guard.text }}
                  </label>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
        }
        <div class="step-actions">
          <button
            cButton
            type="button"
            class="btn-nav-modern"
            [disabled]="currentStep === 1"
            (click)="prevStep()"
          >
            {{ "MANUAL_RESERVATION.BACK" | translate }}
          </button>
          @if (currentStep < totalSteps) {
          <button
            cButton
            type="button"
            class="btn-nav-modern btn-next-modern"
            (click)="nextStep()"
          >
            {{ "MANUAL_RESERVATION.NEXT" | translate }}
          </button>
          } @if (currentStep === totalSteps) {
          <button
            cButton
            type="submit"
            class="btn-submit-modern"
            [disabled]="!allGuardsAccepted()"
          >
            <i class="cil-save me-2"></i>
            {{ "MANUAL_RESERVATION.SAVE_RESERVATION" | translate }}
          </button>
          }
        </div>
      </form>
    </c-card-body>
    <c-card-footer class="powered-sagel text-center">
      <small class="powered-text text-uppercase"
        >{{ "MANUAL_RESERVATION.POWERED_BY" | translate }}
        <span class="text-accent fw-semibold">Sagel</span></small
      >
      <img
        src="assets/img/brand/SAGEL_SMALL.svg"
        alt="Sagel logo"
        class="powered-logo ms-2"
      />
    </c-card-footer>
  </c-card>
  }
  <!-- Terminal success page: the form is gone, so the booking cannot be edited
    or submitted twice. Starting over reloads the page. -->
  @if (isCompleted) {
  <div class="success-page">
    <div class="modal-card success">
      <div class="modal-status-icon">
        <i class="cil-check-circle"></i>
      </div>
      <h3 class="modal-title">
        {{ "MANUAL_RESERVATION.ALERT_SUCCESS_HEADING" | translate }}
      </h3>
      <p class="modal-message">
        {{
          "MANUAL_RESERVATION.ALERT_SUCCESS_MESSAGE"
            | translate
              : {
                  reservationNumber: reservationNumber,
                  num_people: form.personCount,
                  startDate: (form.startDate | date : "EEE MMM dd yyyy"),
                  startTime: form.startTime
                }
        }}
      </p>
      <p class="modal-hint">
        {{ "MANUAL_RESERVATION.ALERT_SUCCESS_ADVICE" | translate }}
      </p>
      <button
        type="button"
        class="modal-action"
        (click)="startNewReservation()"
      >
        {{ "MANUAL_RESERVATION.NEW_RESERVATION_BUTTON" | translate }}
      </button>
    </div>
  </div>
  } @if (showErrorNotification) {
  <div class="modal-overlay">
    <div class="modal-card danger">
      <div class="modal-status-icon">
        <i class="cil-x-circle"></i>
      </div>
      <h3 class="modal-title">
        {{ "MANUAL_RESERVATION.ALERT_ERROR_HEADING" | translate }}
      </h3>
      <p class="modal-message">
        {{ errorText }}
      </p>
      <button type="button" class="modal-action" (click)="onCloseAlert()">
        OK
      </button>
    </div>
  </div>
  } }
</div>
